module.exports = __webpack_public_path__ + "static/media/3DPPA32.1f3c53a7.jpg";